import { useEffect, useState } from 'react'
import { useCartContext } from '../context'

type CheckoutStatus = 'success' | 'cancel' | null

/**
 * Detecta el parámetro `?checkout=success|cancel` con el que Stripe Checkout
 * devuelve al usuario al sitio. En caso de éxito vacía el carrito. En ambos
 * casos limpia el parámetro de la URL para que no persista al recargar.
 */
function readCheckoutParam(): CheckoutStatus {
  const checkout = new URLSearchParams(window.location.search).get('checkout')
  return checkout === 'success' || checkout === 'cancel' ? checkout : null
}

export function useCheckoutResult() {
  const { clearCart } = useCartContext()
  // Lee el parámetro de forma síncrona en el primer render (sin setState en efecto).
  const [status, setStatus] = useState<CheckoutStatus>(readCheckoutParam)

  useEffect(() => {
    if (!status) return

    if (status === 'success') {
      clearCart()
    }

    // Quita ?checkout=... conservando el resto de la URL (incluido el hash de ruta).
    const params = new URLSearchParams(window.location.search)
    params.delete('checkout')
    const query = params.toString()
    const newUrl = `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`
    window.history.replaceState({}, '', newUrl)
    // Solo debe ejecutarse una vez, al montar, para el estado inicial leído de la URL.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const dismiss = () => setStatus(null)

  return { status, dismiss }
}
